import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import styled from 'styled-components';
import createTheme from 'styled-variants';
import { pxToRems } from '@awaze/design-system.components.global-style';
const variants = () => ({
    solid: {},
    ghost: {
        backgroundColor: 'transparent',
    },
    outline: {
        backgroundColor: 'transparent',
        borderWidth: '1px',
        borderStyle: 'solid',
    },
    elevated: {},
});
const colourSchemes = ({ theme, variant }) => ({
    primary: {
        backgroundColor: theme.ColorButtonSolidPrimaryBackground,
        color: variant === 'solid'
            ? theme.ColorButtonSolidPrimaryText
            : theme.ColorButtonGhostPrimaryText,
        borderColor: variant === 'outline'
            ? theme.ColorButtonOutlinePrimaryBorder
            : theme.ColorButtonSolidPrimaryBackground,
    },
    secondary: {
        backgroundColor: theme.ColorButtonSolidSecondaryBackground,
        color: variant === 'solid'
            ? theme.ColorButtonSolidSecondaryText
            : theme.ColorButtonGhostSecondaryText,
        borderColor: variant === 'outline'
            ? theme.ColorButtonOutlineSecondaryBorder
            : theme.ColorButtonSolidSecondaryBackground,
    },
    tertiary: {
        backgroundColor: theme.ColorButtonSolidTertiaryBackground,
        color: variant === 'solid'
            ? theme.ColorButtonSolidTertiaryText
            : theme.ColorButtonGhostTertiaryText,
        borderColor: variant === 'outline'
            ? theme.ColorButtonOutlineTertiaryBorder
            : theme.ColorButtonSolidTertiaryBackground,
    },
    reverse: {
        backgroundColor: theme.ColorButtonSolidReverseBackground,
        color: variant === 'solid'
            ? theme.ColorButtonSolidReverseText
            : theme.ColorButtonGhostReverseText,
        borderColor: variant === 'outline'
            ? theme.ColorButtonOutlineReverseBorder
            : theme.ColorButtonSolidReverseBackground,
    },
});
const BadgeTheme = createTheme('Badge')
    .addVariant('colourScheme', colourSchemes)
    .addVariant('variant', variants);
const BadgeThemed = styled.div(BadgeTheme);
export const BadgeStyled = styled(BadgeThemed) `
  display: inline-block;
  box-sizing: border-box;
  padding: 4px 8px;
  border-radius: 24px;
  line-height: ${({ theme }) => pxToRems(theme.FontTextText100MidLineHeight)};
  font-size: ${({ theme }) => pxToRems(theme.FontTextText100MidFontSize)};
  font-weight: ${({ theme }) => theme.FontTextText100MidFontWeight};
`;
/**
 * A component that highlights a small piece of text or information.
 */
export const Badge = memo(({ colourScheme = 'tertiary', variant = 'solid', text, ...rest }) => {
    return (_jsx(BadgeStyled, { colourScheme: colourScheme, variant: variant, ...rest, children: text }));
});
//# sourceMappingURL=badge.js.map